import React, { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateView } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';

interface CustomDatePickerProps {
  label: string;
  format: string;
  value?: string;
  initialValue?: Dayjs;
  onChange: (val: string) => void;
  fullWidth?: boolean;
  required?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  format,
  value,
  initialValue,
  onChange,
  fullWidth,
  required,
}) => {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);

  useEffect(() => {
    if (selectedDate) {
      onChange(selectedDate.toISOString());
    }
  }, [selectedDate]);

  const dateFormatPicker = (format: string) => {
    let views: readonly DateView[];
    switch (format) {
      case 'YYYY-MM-DD':
        views = ['year', 'month', 'day'];
        break;
      case 'YYYY-MM':
        views = ['year', 'month'];
        break;
      case 'YYYY':
        views = ['year'];
        break;
      default:
        views = ['year', 'month'];
        break;
    }
    return views;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={dateFormatPicker(format)}
        format={format}
        label={`${label}${required ? ' *' : ''}`}
        value={initialValue || selectedDate || (value ? dayjs(value, format) : null)}
        onChange={(newValue) => setSelectedDate(newValue)}
        sx={{
          width: fullWidth ? '100%' : 'auto',
          '& .MuiInputBase-root': {
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: '1.875rem',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#737F86',
          },
        }}
        slotProps={{
          textField: {
            inputProps: {
              readOnly: true,
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
